import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./StudentReviewVideos.css";

const StudentReviewVideos = () => {
  const videos = [
    {
      id: "Ckw7uIF5Jfw",
      title: "Video 1",
    },
    {
      id: "AjUq1s8UrOY",
      title: "Video 2",
    },
    {
      id: "zpRFluI9yiU",
      title: "Video 3",
    },
    {
      id: "RAg1koQ9A08",
      title: "Video 4",
    },
    {
      id: "eOsVfl-FXt0",
      title: "Video 5",
    },
    {
      id: "sYec-i9gefA",
      title: "Video 6",
    },
    {
      id: "-M9v45wUuao",
      title: "Video 7",
    },
    {
      id: "VnjKFKKuHLU",
      title: "Video 8",
    },
    {
      id: "k7YNWq_995Q",
      title: "Video 9",
    },
    {
      id: "3zTG4G0yybo",
      title: "Video 10",
    },
    {
      id: "mnwvpBttKdc",
      title: "Video 11",
    },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="student-review-container">
      <div className="video-carousel-section">
        <Slider {...settings}>
          {videos.map((video, index) => (
            <div key={index} className="carousel-video-wrapper">
              <div className="video-card">
                <iframe
                  src={`https://www.youtube.com/embed/${video.id}`}
                  title={video.title}
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default StudentReviewVideos;
